import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import LandingPage from './components/landingpage/LandingPage';
import PrivacyPolicy from './components/landingpage/PrivacyPolicy';
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/home" element={<LandingPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
